import React from 'react';
import { Flex, Progress } from '@highereducation/hen-ui';
import { Modal } from './Modal';
import { useDynamicExperienceContext } from '@de/providers/DynamicExperienceProvider';
import { StepType } from '@de/types/enums';
import { useFlowProgress } from '@de/hooks/useFlowProgress';

export interface ExperienceWrapperProps {
  children: React.ReactNode;
  contentRef: React.RefObject<HTMLDivElement>;
}

/**
 * Wrapper component for the experience flow
 * Handles layout, progress tracking, and navigation
 */
export const ExperienceWrapper: React.FC<ExperienceWrapperProps> = ({
  children,
}) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const { currentStep, currentStepType, styleVariant, openModal } =
    useDynamicExperienceContext();
  const modal = currentStep?.modal;
  const hideProgressBar = currentStep?.isTerminal && currentStep?.isEntry;
  const progress = useFlowProgress();

  // Result type renders differently
  if (currentStepType === StepType.RESULT) {
    return (
      <div className='de-experience-container h-full'>
        <div className='de-step-container bg-gray-50 h-full'>{children}</div>
      </div>
    );
  }

  return (
    <Flex
      direction='column'
      gap='lg'
      className='de-experience-wrapper md:flex-1 bg-white not-prose p-0'
      ref={wrapperRef}
    >
      {/* Progress Bar - only show for default variant */}
      {styleVariant === 'default' && !hideProgressBar && (
        <Progress
          value={progress}
          label='Your Progress'
          valueLabel={`${Math.round(progress)}% complete`}
          className='[&>div]:!bg-secondary-700'
        />
      )}

      <div className='de-step-container'>{children}</div>

      <Modal modal={modal} openModal={openModal} />
    </Flex>
  );
};

export default ExperienceWrapper;
